import React, { useEffect, useState } from "react"
import styled from "styled-components"
import SwiperCore, { Navigation, Pagination } from "swiper"
import "swiper/swiper-bundle.min.css"

import { CustomComponentImages } from "../../types"
import { SecondaryHeading } from "./heading.component"

SwiperCore.use([Navigation, Pagination])

const Section = styled.section`
  background-color: #f4f5f7;
`
const Container = styled.div`
  --max-width: 1260px;
  width: calc(100% - 40px);
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 80px 0;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`

const StyledSecondaryHeading = styled(SecondaryHeading)`
  max-width: 100%;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    max-width: 146px;
    text-align: left;
  }
`

const FeatureCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
  max-width: 250px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    max-width: 250px;
  }
`

const IconWrapper = styled.div`
  background: white;
  padding: 24px;
  border-radius: 50%;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const FeatureTitle = styled.h3`
  font-family: Facto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin: 0;
  margin-bottom: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    font-size: 23px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
`

const StyledSwiper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    margin: 0;
    margin-left: 0;
    margin-right: 0;
  }
  margin: 32px 0;
  margin-top: 80px;
  display: flex;
  flex-direction: row;
  gap: 80px;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    display: flex;
    flex-direction: column;
    gap: 80px;
    align-items: center;
  }
`

export interface TextWithListSliderConfig {
  listWithImages: {
    heading: string
    list: {
      text: string
    }[]
  }
}

const TextWithListSlider = ({
  config,
  images,
}: {
  config: TextWithListSliderConfig
  images: CustomComponentImages[]
}) => {
  const [swiper, __] = useState<SwiperCore>()
  const [_, setActiveIndex] = useState(0)
  // const { dynamicTranslate } = useTranslationHook()

  useEffect(() => {
    if (swiper) {
      setActiveIndex(swiper.activeIndex)
    }
  }, [swiper?.activeIndex])

  return (
    <Section>
      <Container>
        <StyledSecondaryHeading>
          {config.listWithImages.heading}
        </StyledSecondaryHeading>

        <StyledSwiper>
          {config.listWithImages.list.map((feature, index) => (
            <FeatureCard key={index}>
              <IconWrapper>
                <img src={images[index].file.url} alt={images[index].title} />
              </IconWrapper>
              <FeatureTitle>{feature.text}</FeatureTitle>
            </FeatureCard>
          ))}
        </StyledSwiper>
      </Container>
    </Section>
  )
}

export default TextWithListSlider
